const thirdParty = {
  thirdParty: {
    pageHeader: 'Raportowanie podmiotów trzecich',
    clearState: 'Usuń województwo',
    register: 'Zarejestruj',
    systemRegistrationSummary: 'Podsumowanie rejestracji systemu',
    registrationProgress: '%{registration_in_progress} w toku',
    registrationComplete: '%{registration_complete} ukończono',
    thirdPartyLogin: 'Zaloguj się jako właściciel lokalizacji, aby zarządzać swoim kontem PowerDash',
    thirdPartyInvalidURI: 'Żądany identyfikator URI jest nieprawidłowy lub żądany zasób, np. system, nie istnieje.'
  }
};

export default thirdParty;
